// Timestamp parsing and display for API values (#319).
//
// Lives here rather than inside a page because more than one screen renders the
// same `created_at` values, and the first version of the #319 fix only updated
// TransactionHistory — leaving CreditRecharge printing a raw ISO string in its
// Date column. One formatter, used everywhere, is what stops that recurring.

/**
 * Parse a timestamp from the API into a Date.
 *
 * The API emits ISO-8601 with an offset, which is unambiguous. The legacy
 * "dd-mm-yyyy HH:ii:ss" shape carried no timezone at all and JS parses it as
 * browser-local — which is exactly how #319 worked — so that branch pins it to
 * IST rather than letting the viewer's machine decide.
 */
export const parseApiDate = (s) => {
    if (!s) return null;

    const str = String(s);

    if (/\d{4}-\d{2}-\d{2}T/.test(str)) {
        const d = new Date(str);
        return Number.isNaN(d.getTime()) ? null : d;
    }

    const m = str.match(/(\d{2})-(\d{2})-(\d{4})\s+(\d{2}):(\d{2}):(\d{2})/);
    if (!m) return null;

    const d = new Date(`${m[3]}-${m[2]}-${m[1]}T${m[4]}:${m[5]}:${m[6]}+05:30`);
    return Number.isNaN(d.getTime()) ? null : d;
};

// Rendered in IST for every viewer. This is an India-only product and these are
// money ledgers: a row must say when the transaction happened in the timezone
// the user banks in, not in whichever zone their laptop is set to.
const IST = { timeZone: 'Asia/Kolkata' };

/** "01 Aug 2026 · 12:30 AM" */
export const formatDateTime = (value) => {
    const d = parseApiDate(value) || (value ? new Date(value) : null);
    if (!d || Number.isNaN(d.getTime())) return value || '—';

    return `${d.toLocaleDateString('en-IN', { ...IST, day: '2-digit', month: 'short', year: 'numeric' })}`
        + ` · ${d.toLocaleTimeString('en-IN', { ...IST, hour: '2-digit', minute: '2-digit', hour12: true })}`;
};
